import { render, staticRenderFns } from "./monitorList.vue?vue&type=template&id=af733c4a&scoped=true"
import script from "./monitorList.vue?vue&type=script&lang=js"
export * from "./monitorList.vue?vue&type=script&lang=js"
import style0 from "./monitorList.vue?vue&type=style&index=0&id=af733c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af733c4a",
  null
  
)

export default component.exports